import React, { useState, useEffect, useRef } from "react";
import useStyles from "./styles";
import {
    Breadcrumbs,
    Button,
} from "@material-ui/core";
import { Link } from 'react-router-dom';


import ArrowRightIcon from '@material-ui/icons/ArrowRight';

import { useHistory } from "react-router-dom";
import EmptyGrid from './../../assets/img/emptyGrid.svg';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';

export default function Breadcrums({ parentLink, parentURL, gobackAction, isBack, BackUrl, currentLink, currentURL, childText, ...props }) {
    const classes = useStyles();
    const history = useHistory();
   
    const pushRoute = () => {
        history.push(BackUrl)
    }
    const goBack = () => {
        history.goBack()
        setTimeout(() => {
            window.scrollTo(0, 0)
        }, 100)
    }
    return (
        <>
            <Breadcrumbs separator={<ArrowRightIcon />} aria-label="breadcrumb" className={classes.customBreadcrumbs}>

          
                    <span className={classes.parantLink}>{parentLink}</span>
            

              
                    <span className={classes.childLink}>  {currentLink}</span>
              

                {childText ?
        
                        <span className={classes.childLink}>  {childText}</span>
                  : ''
                }

            </Breadcrumbs>

            {isBack ?
                <Button className={classes.changeBtn} onClick={gobackAction ? gobackAction : goBack}>
                    <ArrowBackIosIcon /> Go Back
                </Button> : ''
            }

              {BackUrl ?
                <Button className={classes.changeBtn} onClick={pushRoute}>
                    <ArrowBackIosIcon /> Go Back
                </Button> : ''
            }


        </>
    )
}
